import React from 'react';
import { MainContentCrash } from './MainContentCrash';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class CrashHandler extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error) {
    console.log(error);
    if (window.Rollbar)
      window.Rollbar.critical(error, { source: 'page content' });
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <MainContentCrash />;
    }

    return children;
  }
}
